<section class="header">
  <ion-header class="ion-no-border">
    <div class="d-flex header__content">
      <ion-item
      class="header__items ion-no-padding"
      lines="none"
      placement="start"
    >
        @if(tabs['users']) {
          <ion-label class="header__items__item" [ngClass]="{ active: tabSelected === 'users' }">
            <a class="header__items__item__link" (click)="selectTab('users')">Gestión de usuarios</a>
          </ion-label>
        } @if(tabs['requests']) {
          <ion-label class="header__items__item" [ngClass]="{ active: tabSelected === 'requests' }">
            <a class="header__items__item__link" (click)="selectTab('requests')">Gestión de solicitudes</a>
          </ion-label>
        }
      </ion-item>
    </div>
  </ion-header>
</section>
@if(tabSelected === 'users') {
<app-managements-users [filterNameList]="filterNameList" [filterCompanyList]="filterCompanyList" />
} @else if(tabSelected === 'requests') {
<app-managements-requests [filterContentList]="filterContentList" [filterNameList]="filterNameList" [filterCompanyList]="filterCompanyList" />
}
